import React, { useEffect } from 'react';
import { COPY } from './copy';

const TITLE_ID = 'rai-confirm-send-modal-title';

const Backdrop = ({ children, onClose, labelledBy }) => (
  <div
    role="dialog"
    aria-modal="true"
    aria-labelledby={labelledBy}
    onClick={onClose}
    style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000,
    }}
  >
    <div onClick={(e) => e.stopPropagation()} style={{ background: 'white', borderRadius: 8, padding: 24, maxWidth: 540, width: '90%' }}>
      {children}
    </div>
  </div>
);

const ConfirmSendModal = ({ open, onCancel, onConfirm, submitting }) => {
  useEffect(() => {
    if (!open) return undefined;
    const handler = (e) => { if (e.key === 'Escape' && !submitting) onCancel(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, submitting, onCancel]);

  if (!open) return null;

  return (
    <Backdrop onClose={onCancel} labelledBy={TITLE_ID}>
      <h2 id={TITLE_ID} className="text-lg font-semibold mb-4">{COPY.modal.confirmTitle}</h2>
      <div className="flex flex-row gap-x-3 justify-end mt-6">
        <button
          type="button"
          onClick={onCancel}
          disabled={submitting}
          className="btn btn-ghost"
        >
          {COPY.buttons.cancel}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={submitting}
          className="btn btn-primary"
        >
          {COPY.buttons.send}
        </button>
      </div>
    </Backdrop>
  );
};

export default ConfirmSendModal;
